import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { MyRewardCardStyled } from "./styled";
import { IMG_PATH } from "utils/constants/imgPath";
// import { IMG_PATH } from "utils/constants/imgPath";
import { Displays } from "components";

const MyRewardCard = ({ theme_standard, reward_detail }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  return (
    <MyRewardCardStyled>
      <div className={customClass}>
        <div className="new_container">
          <div className="new_img_wrap">
            {/* <img
              className="new_img"
              alt="news yamaha"
              src={
                reward_detail.img
                  ? IMG_PATH + reward_detail.img
                  : "/assets/images/icons/mock-my-reward.png"
              }
            /> */}
            <Displays.ImageSmooth
              src={
                reward_detail.img
                  ? IMG_PATH + reward_detail.img
                  : "/assets/images/mockups/activity-news.jpg"
              }
              alt="reward"
              aspectRatio="1 / 1"
            />
          </div>
          <div className="new_content_block">
            <div className="n_header">{reward_detail.name}</div>
            <div
              className="n_description"
              dangerouslySetInnerHTML={{ __html: reward_detail.description }}
            />
          </div>
        </div>
      </div>
    </MyRewardCardStyled>
  );
};

MyRewardCard.propTypes = {};

export default MyRewardCard;
